export default __webpack_public_path__ + "static/media/hero_image.6a99623c.png";